(function($) {
	$( document ).ready(
		function() {
			$( '.tab' ).click(
				function(e) {
					if ($( this ).hasClass( 'active' )) {
						e.preventDefault()
					} else {
						var target = $( this ).attr( 'data-tabid' );
						$( this ).addClass( 'active' )
						$( this ).siblings().removeClass( 'active' )
						$( '.tabContent' ).removeClass( 'active' )
						$( '.tabContent[data-tabid="' + target + '"]' ).addClass( 'active' )
					}
				}
			);
		}
	)
})( jQuery );
